import { IROVVideoMinimal } from 'src/generated-types/rovvideo'

export type RovVideoPlaybackSource =
  | { kind: 'blob'; url: string }
  | { kind: 'vimeo'; vimeoId: string }
  | { kind: 'none' }

export const getRovVideoPlaybackSource = (
  rovvideo: Pick<IROVVideoMinimal, 'azureBlobURL' | 'vimeoId'> | null | undefined,
): RovVideoPlaybackSource => {
  if (!rovvideo) return { kind: 'none' }
  if (rovvideo.azureBlobURL) return { kind: 'blob', url: rovvideo.azureBlobURL }
  if (rovvideo.vimeoId) return { kind: 'vimeo', vimeoId: rovvideo.vimeoId }
  return { kind: 'none' }
}
